<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.46875 5.88814C5.46875 4.99681 6.42437 4.43178 7.20537 4.86133L19.2268 11.4731C20.0363 11.9183 20.0363 13.0815 19.2268 13.5268L7.20537 20.1385C6.42437 20.5681 5.46875 20.0031 5.46875 19.1117V5.88814Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgPlay',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
